import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ActiveInactiveFor, KeyValues3, LocalService, Status, TriggeredEvent, Wrappers3 } from '../../../service/local.service';
import { LanguagesContentComponent } from '../../popups/languages-content/languages-content.component';

@Component({
  selector: 'app-language-contents-all',
  templateUrl: './language-contents-all.component.html',
  styleUrls: ['./language-contents-all.component.scss']
})
export class LanguageContentsAllComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["table"];
  source: Wrappers3; maxBodyHeight = 0;
  sectionId: string = '';
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private modalService: NgbModal, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.sectionId = this.route.snapshot.paramMap.get('id');
    if (this.sectionId == '0' || this.sectionId == '')
      this.sectionId = '';
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.languageManagementService.getLanguageConfigSection(this.sectionId, this.source == undefined ? null : this.source.paging, true).subscribe(result => {
      this.source = result;
    });
  }

  onActiveInactiveStatus(strId: string) {
    this.languageManagementService.activeInactiveStatus(strId, ActiveInactiveFor.LanguageSection).subscribe(result => {
      if (result == Status.Success) {
        const updatedItem = this.source.items.find(x => x.key == strId);
        updatedItem.v2 = updatedItem.v2 == "1" ? "0" : "1";
      }
    });
  }

  openLanguageContent(id: string) {
    const modalRef = this.modalService.open(LanguagesContentComponent, { ariaLabelledBy: 'modal-basic-title' });
    modalRef.componentInstance.id = id;
    modalRef.componentInstance.sectionId = this.sectionId;
    modalRef.result.then((result) => {
      if (result.event == TriggeredEvent.Ok) {
        if (id == '') {
          let content = result.wrapper.languageContents[0].content;
          let wrapper = {
            v1: result.wrapper.content.key,
            v3: content ? content.value : ''
          } as KeyValues3;
          this.source.items.push(wrapper);
        }
        else {
          const temp = this.source.items.find(x => x.key == result.wrapper.id);
          temp.key = result.wrapper.content.key;
          temp.v3 = result.wrapper.languageContents[0].content.value;
        }
      }
    });
  }
}
